module.exports = __webpack_public_path__ + "img/1457514708.8c73ef44.jpg";